import { useState, useEffect } from 'react';

interface StartScreenProps {
  onStart: () => void;
}

const GAME_INFO = {
  name: '순서 기억하기',
  tag: '단기기억',
};

const PREVIEW_SEQUENCE = [1, 4, 7];

export default function StartScreen({ onStart }: StartScreenProps) {
  const [activeCount, setActiveCount] = useState(0);

  useEffect(() => {
    const steps = [1, 2, 3, 3, 3, 3, 0];
    let i = 0;
    const interval = setInterval(() => {
      setActiveCount(steps[i % steps.length]);
      i += 1;
    }, 700);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative h-full animate-fade-in-up">
      <div className="flex flex-col h-full px-6 pt-8 pb-6">
        {/* 제목 영역 */}
        <div className="text-center mb-5 shrink-0">
          <h1 className="text-2xl font-bold text-foreground-900 leading-tight">
            {GAME_INFO.name}
          </h1>
          <p className="text-sm font-medium text-primary-600 mt-1.5">
            #{GAME_INFO.tag}
          </p>
        </div>

        {/* 안내 콘텐츠 카드 */}
        <div className="w-full flex-1 min-h-0 bg-white rounded-2xl border border-secondary-200 px-6 py-6 flex flex-col items-center">
          {/* 안내 문구 */}
          <p className="text-base font-semibold text-foreground-800 text-center leading-relaxed shrink-0">
            불이 켜지는 위치를 기억한 뒤,
            <br />
            같은 순서대로 눌러주세요.
          </p>

          {/* 3x3 보드 - 카드 중앙 고정 */}
          <div className="flex-1 flex items-center justify-center w-full min-h-0">
            <div className="grid grid-cols-3 gap-3 max-w-[280px] w-full">
              {Array.from({ length: 9 }).map((_, index) => {
                const order = PREVIEW_SEQUENCE.indexOf(index);
                const isActive = order >= 0 && order < activeCount;
                return (
                  <div
                    key={index}
                    className={`
                      aspect-square rounded-2xl border-2
                      flex items-center justify-center
                      transition-all duration-300
                      ${isActive
                        ? 'bg-accent-500 border-accent-400 scale-105 shadow-[0_0_24px_oklch(var(--accent-500)/0.45)]'
                        : 'bg-white border-secondary-300'}
                    `}
                  >
                    {isActive && (
                      <span className="text-white text-lg font-bold leading-none">
                        {order + 1}
                      </span>
                    )}
                  </div>
                );
              })}
            </div>
          </div>
        </div>

        {/* 하단 버튼 */}
        <div className="w-full mt-5 pb-2 shrink-0">
          <button
            onClick={onStart}
            className="w-full py-4 px-6 rounded-2xl bg-white text-primary-700 font-semibold text-lg whitespace-nowrap
              border-2 border-primary-200
              active:scale-[0.98] transition-transform duration-150
              hover:bg-primary-50"
          >
            게임 시작하기
          </button>
        </div>
      </div>
    </div>
  );
}